module.exports = __webpack_public_path__ + "static/media/cash.0a3a022c.JPG";